var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.6 3.10005V0.300049C9.6 0.300049 6.7 0.300049 6.5 0.300049C5.2 0.300049 3.3 1.80005 3.3 3.50005C3.3 5.40005 3.3 6.60005 3.3 6.60005H0.5V9.90005H3.2V18H6.4V9.90005H9.2L9.6 6.70005H6.4C6.4 6.70005 6.4 4.70005 6.4 4.40005C6.4 3.80005 6.8 3.30005 7.5 3.30005C8 3.10005 9.6 3.10005 9.6 3.10005Z"}));
}

Facebook.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 10 18"};

module.exports = Facebook;

Facebook.default = Facebook;
